import {
  Calendar,
  Clock,
  CheckCircle,
  MapPin,
  Phone,
  Mail,
  Briefcase,
  User,
  Play,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useSWR from "swr";
import { useAuth } from "../../../context/AuthProvider";
import { usePublicMeetingStore } from "../../../store/public.meeting.store";
import { openAdvocatePrejoinTab } from "../../../utils/advocateLobbyJoin";
// import MeetingSFU from "../../../components/meeting/MeetingSFU";
const AdvocateDashboard = () => {
  // const { socket } = useSocket();
  const { user } = useAuth();
  const navigate = useNavigate();
  const { data } = useSWR(`/api/advocate/dashboard`);
  const advocateInfo = data?.data?.advocateInfo;
  const todaysSchedule = data?.data?.todaysSchedule;
  const todaysCourts = data?.data?.todaysCourts;
  const setMeetingState = usePublicMeetingStore(
    (state) => state.setMeetingState,
  );

  const getScheduleStatus = (status: string) => {
    switch (status) {
      case "upcoming":
        return (
          <span className="flex items-center gap-1 text-blue-600">
            <Clock size={12} />
            Upcoming
          </span>
        );
      case "live":
        return (
          <span className="flex items-center gap-1 text-red-600">
            <Play size={12} />
            Live Now
          </span>
        );
      case "completed":
        return (
          <span className="flex items-center gap-1 text-green-600">
            <CheckCircle size={12} />
            Completed
          </span>
        );
      default:
        return null;
    }
  };

  const handleJoinLive = async (item: any) => {
    try {
      setMeetingState("prejoin");
      if (item) {
        const state = {
          caseNumber: item.cnr,
          user,
          navigateFrom: "advocate-dashboard",
          cases: todaysSchedule,
        };
        const opened = openAdvocatePrejoinTab(state);
        if (opened) return;

        navigate("/meeting", {
          state,
        });
      } else if (!item) {
        toast.error("No cases scheduled for today.");
      } else {
        toast.error("Please allow camera and microphone access to proceed.");
      }
    } catch (error: any) {
      toast.error("Error accessing camera and microphone: " + error.message);
    }
  };
  return (
    <div className="p-2 md:p-4">
      {/* <MeetingSFU roomId="COURT-101" role="Advocate" /> */}
      {/* Quick Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4 mb-8">
        {/* Profile Summary */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200  p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Profile Summary
          </h3>
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                <User className="text-white" size={20} />
              </div>
              <div>
                <p className="font-medium text-gray-900">
                  {advocateInfo?.name}
                </p>
                <p className="text-sm text-gray-600">
                  {advocateInfo?.specialization}
                </p>
              </div>
            </div>

            <div className="space-y-2 text-sm">
              {/* <div className="flex items-center gap-2">
                <Scale size={14} className="text-gray-400" />
                <span className="text-gray-600">Experience:</span>
                <span className="text-gray-900">
                  {advocateInfo?.experience}
                </span>
              </div> */}
              <div className="flex items-center gap-2">
                <Phone size={14} className="text-gray-400" />
                <span className="text-gray-900">{advocateInfo?.phone}</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={14} className="text-gray-400" />
                <span className="text-gray-900">{advocateInfo?.email}</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={14} className="text-gray-400" />
                <span className="text-gray-900">
                  {advocateInfo?.location ||
                    advocateInfo?.chambers ||
                    advocateInfo?.address ||
                    "—"}
                </span>
              </div>
            </div>

            {/* <div className="pt-4 border-t">
              <div className="grid grid-cols-2 gap-4 text-center">
                <div>
                  <p className="text-2xl font-bold text-blue-600">
                    {advocateInfo.totalCases}
                  </p>
                  <p className="text-xs text-gray-600">Total Cases</p>
                </div>
                <div>
                  <p className="text-2xl font-bold text-green-600">
                    {advocateInfo.completedCases}
                  </p>
                  <p className="text-xs text-gray-600">Completed</p>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        <div className="h-full">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200  p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">
                  Today's Hearings
                </p>
                <p className="text-3xl font-bold text-green-600">
                  {todaysSchedule?.length}
                </p>
                {/* <p className="text-xs text-blue-600 mt-1">1 live now</p> */}
              </div>
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <Calendar className="text-green-600" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mt-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">
                  Today's Court Appearances
                </p>
                <p className="text-3xl font-bold text-blue-600">
                  {todaysCourts?.length}
                </p>
                <p className="text-xs text-green-600 mt-1"> </p>
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <Briefcase className="text-blue-600" size={24} />
              </div>
            </div>
          </div>
        </div>

        <div className="h-full">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200  p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">
                  Today's Total Cases
                </p>
                <p className="text-3xl font-bold text-green-600">
                  {todaysSchedule?.length}
                </p>
                {/* <p className="text-xs text-blue-600 mt-1">1 live now</p> */}
              </div>
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                <Calendar className="text-green-600" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mt-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">
                  Today's Active Cases
                </p>
                <p className="text-3xl font-bold text-blue-600">
                  {advocateInfo?.todayActiveCases}
                </p>
                {/* <p className="text-xs text-green-600 mt-1">+3 this month</p> */}
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <Briefcase className="text-blue-600" size={24} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 md:gap-4">
        {/* Today's Schedule */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200">
          <div className="p-4 md:p-6 border-b">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold text-gray-900">
                Today's Schedule
              </h2>
            </div>
          </div>
          <div className="p-4 md:p-6">
            <div className="space-y-4">
              {todaysSchedule?.map((item: any, index: number) => (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow"
                >
                  <div className="flex items-center justify-between sm:justify-start sm:flex-col sm:w-16">
                    <div className="text-center">
                      <p className="text-sm font-medium text-gray-900">
                        {item.time}
                      </p>
                      <div className="mt-1">
                        {getScheduleStatus(item.status)}
                      </div>
                    </div>
                    {item.status === "live" && (
                      <button
                        onClick={() => handleJoinLive(item)}
                        className="sm:hidden bg-red-600 text-white px-3 py-1 rounded-lg text-xs hover:bg-red-700"
                      >
                        Join Session
                      </button>
                    )}
                  </div>

                  <div className="flex-1 min-w-0">
                    <h3 className="font-medium text-gray-900 mb-1 break-words">
                      {item.caseTitle}
                    </h3>
                    <p className="text-sm text-gray-600 flex items-center gap-1 mb-1">
                      <MapPin size={12} className="flex-shrink-0 mt-0.5" />
                      <span className="break-words">{item.court}</span>
                    </p>
                    <p className="text-xs text-gray-500 break-all">
                      CNR: {item.cnr}
                    </p>
                  </div>

                  <div className="flex items-center justify-between sm:flex-col sm:items-end gap-2">
                    <span className="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded-full whitespace-nowrap">
                      {item.caseStage}
                    </span>
                    {item.status === "live" && (
                      <button
                        onClick={() => handleJoinLive(item)}
                        className="hidden sm:block bg-red-600 text-white px-3 py-1 rounded-lg text-xs hover:bg-red-700 whitespace-nowrap"
                      >
                        Join Session
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Courts Table */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200">
          <div className="p-4 md:p-6 border-b">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold text-gray-900">Courts</h2>
            </div>
          </div>

          {/* Mobile view - Cards */}
          <div className="block sm:hidden p-4 space-y-4">
            {todaysCourts?.map((item: any, index: number) => (
              <div
                key={index}
                className="border border-gray-200 rounded-lg p-4"
              >
                <div className="flex justify-between items-start mb-2">
                  <span className="font-medium text-gray-900">
                    #{index + 1}
                  </span>
                </div>
                <div className="space-y-1">
                  <p className="text-sm font-medium text-gray-900">
                    {item.court}
                  </p>
                  <p className="text-sm text-gray-600">Mumbai, Maharashtra</p>
                </div>
              </div>
            ))}
          </div>

          {/* Desktop/Tablet view - Table */}
          <div className="hidden sm:block overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Sr
                  </th>
                  <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Court Name
                  </th>
                  <th className="px-4 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Location
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {todaysCourts?.map((item: any, index: number) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 md:px-6 py-4">
                      <p className="font-medium text-gray-900">{index + 1}</p>
                    </td>
                    <td className="px-4 md:px-6 py-4">
                      <span className="text-sm text-gray-900">
                        {item.court}
                      </span>
                    </td>
                    <td className="px-4 md:px-6 py-4">
                      <span className="text-sm text-gray-900">
                        {item.location}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvocateDashboard;
